var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-screen h-screen bg-contain bg-no-repeat bg-center",style:({
    'background-image': ("url(" + _vm.image + ")"),
    'background-color': '#ecfbfe'
  })},[_c('base-button',{staticClass:"m-4",attrs:{"color":"transparent","borderless":""},on:{"click":_vm.goBack}},[_c('div',{staticClass:"text-brand-blue"},[_c('fa-icon',{attrs:{"icon":"arrow-left"}}),_c('span',{staticClass:"ml-2"},[_vm._v("Go Back")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }